// ============================================================
// FILE: src/components/SmoothScroll.jsx  →  SMOOTH SCROLLING
// Gives the whole site its buttery momentum scrolling (Lenis).
// YOU RARELY NEED TO EDIT THIS FILE.
// ============================================================

import { useEffect } from "react";
import Lenis from "lenis";

export default function SmoothScroll({ children }) {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.14, wheelMultiplier: 1, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    window.__lenis = lenis;
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);
  return children;
}
